import { render } from "./FeedbackThumbs.vue?vue&type=template&id=31128fb0&scoped=true"
import script from "./FeedbackThumbs.vue?vue&type=script&lang=js"
export * from "./FeedbackThumbs.vue?vue&type=script&lang=js"

import "./FeedbackThumbs.vue?vue&type=style&index=0&id=31128fb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31128fb0"]])

export default __exports__